import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../../../assets/svg/logoIcon";
import { useAuth } from "../../../context/authContext";
import createAxiosInstance from "../../../utils/axiosConfig";
import { useCases } from "../../../utils/constants";
import { UseCase } from "../../../utils/interfaces";

const ChatHeader = ({
	useCase,
	selectUseCase,
}: {
	useCase: number;
	selectUseCase: (selectedCase: number) => void;
}) => {
	const [accountType, setAccountType] = useState<number>(0);
	const [dayGreet, setDayGreet] = useState<string>("");
	const [userLogo, setUserLogo] = useState<string>("");
	const { logout, login} = useAuth();
	const navigate = useNavigate();
	const handleLogout = () => {
		logout();
		navigate("/");
	};

	const getUserLogo = async () => {

		try {
			const axiosInstance = createAxiosInstance({
				"Content-Type": "multipart/form-data",
			});
			const response = await axiosInstance.get(`/logo/${userData?.id}`, {
				responseType: "arraybuffer",
			});
			if(response.status == 401 || response.status === 403) {
				logout();
				navigate("/");
			}
			const contentType = response.headers["content-type"];
			const base64 = btoa(
				new Uint8Array(response.data).reduce(
					(data, byte) => data + String.fromCharCode(byte),
					""
				)
				);

			if (response.data?.byteLength > 40){
				setUserLogo(`data:${contentType};base64,${base64}`);
			}
			else{
				setUserLogo("");
			}
		} catch (error: any) {
			console.log(error, "error");
			if(error?.status == 401 || error?.status === 403) {
				logout();
				navigate("/");
			}
		}
	};

	useEffect(() => {
		const storedUserData = localStorage.getItem("userData");
		const userData = JSON.parse(storedUserData || "{}");

		if (userData?.account_type) {
			setAccountType(userData?.account_type);
		}

		setDayGreet(getGreeting());
		getUserLogo();
	}, []);

	function getGreeting(): string {
		// Get the current hour of the day
		const today = new Date();
		const hour = today.getHours(); // Returns a number from 0 (midnight) to 23 (11 PM)
		// Determine the appropriate greeting based on the hour
		let greeting: string;
		if (hour >= 0 && hour < 5) {
			greeting = "Hi,";
		} else if (hour > 4 && hour < 12) {
			greeting = "Good morning!";
		} else if (hour < 18) {
			greeting = "Good day!";
		} else {
			greeting = "Good evening!";
		}

		return greeting;
	}

	const handleBackToPersonalAccount = async () => {
		const personal_token = localStorage.getItem('parent_token')
		const personal_data = JSON.parse(localStorage.getItem('parent_data') || "{}");
		const personal_id = localStorage.getItem('parent_id');
		login(Number(personal_id), personal_token || "", {...personal_data, is_customer_account: false});
		navigate('/manageCustomers');
	}

	const userData = JSON.parse(localStorage.getItem("userData") || "{}");
	return (
		<header className="main-header">
			<div className="container">
				<nav className="navbar navbar-expand-lg">
					<div className="container-fluid d-flex justify-content-between">
						<a className="" href="/">
							<LogoIcon />
						</a>
						{userLogo !== "" && (
							<div className="d-flex mt-3" style={{width: "10%"}}>
								
									<img
										src={userLogo}
										alt="User Logo"
										className="user-logo"
										style={{
											maxWidth: "70%",
											maxHeight: "10%",
										}}
									/>
								
							</div>
						)}
						<ul className="navbar-nav me-auto ms-md-5 d-flex justify-content-start">
							<li className="nav-item">
								<select
									name=""
									id=""
									className="form-select"
									onChange={(e) => {
										selectUseCase(Number(e.target.value));
									}}
									value={useCase}
								>
									<option value="0" disabled>
										Areas of Interest
									</option>
									{useCases.map((useCase: UseCase, key) => (
										<option
											value={useCase.value}
											key={`use_case_options_${key}`}
											selected={useCase.value == Number(useCase)}
										>
											{useCase.name}
										</option>
									))}
								</select>
							</li>
						</ul>
						
						<div>
							{
								userData.is_customer_account && <button className="btn btn-sm btn-primary" style={{
									marginRight: '10%'
								}} onClick={handleBackToPersonalAccount}>Back to Personal Account</button>
							}
						</div>
						<div className="d-flex">
							<div className="dropdown">
								<a
									className="btn btn-light dropdown-toggle rounded"
									href="#"
									role="button"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									<i className="bi bi-person"></i>
									<span className="d-none d-sm-inline-block">
										{dayGreet}
										{userData?.first_name && ` ${userData?.first_name} `}
									</span>
								</a>
								<ul className="dropdown-menu">
									<li>
										<a className="dropdown-item" href="/pricing">
											<i className="bi bi-bookmark-star"></i>{" "}
											{accountType == 0
												? "Upgrade to Enterprise "
												: "Enterprise Account"}
											{""}
										</a>
									</li>
									<li>
										<a className="dropdown-item" href="/feedback">
											<i className="bi bi-file-earmark-text"></i> Feedback Form
										</a>
									</li>
									<li>
										<a className="dropdown-item" href="/changeAccountPassword">
											<i className="bi bi-key"></i> Change Password
										</a>
									</li>

									{userData?.is_admin && (
										<li>
											<a className="dropdown-item" href="/adminFeatures">
												<i className="bi bi-robot"></i> Administration
											</a>
										</li>
									)}
									{(userData?.account_type === 2 || userData?.is_admin) && (
										<li>
											<a className="dropdown-item" href="/addData">
												<i className="bi bi-cloud-plus"></i> Add Data
											</a>
										</li>
									)}
									{userData?.is_admin && (
										<li>
											<a className="dropdown-item" href="/viewFormData">
												<i className="bi bi-cloud-plus"></i> View Data
											</a>
										</li>
									)}
									{
										userData?.account_type === 3 && (
											<li>
												<a className="dropdown-item" href="/registerCustomers">
												<i className="bi bi-person-add"></i> Add Customers
												</a>
											</li>
										)
									}
									{userData?.account_type === 3 && (
										<li>
											<a className="dropdown-item" href="/manageCustomers">
												<i className="bi bi-cloud-plus"></i> Manage Customers
											</a>
										</li>
									)}
									<li>
										<a className="dropdown-item" href="/privacy-policy">
											<i className="bi bi-file-earmark-lock"></i> Privacy Policy
										</a>
									</li>
									<li>
										<a className="dropdown-item" href="/terms-and-conditions">
											<i className="bi bi-file-earmark-ruled"></i> Terms &
											Conditions
										</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											href="#"
											onClick={handleLogout}
										>
											<i className="bi bi-lock"></i> Log out
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</header>
	);
};

export default ChatHeader;
